<template>
  <div
    :class="classList"
    @click="onClick"
    tabindex="0"
    @keyup.enter="onClick"
  >
    <slot/>
  </div>
</template>

<script setup>
  import { computed } from 'vue';

  const props = defineProps({
    item: {
      type: Object,
      required: true,
    },
    isSelectedFn: {
      type: Function,
      required: true,
    },
    stateFn: {
      type: Function,
      required: true,
    },
  });

  const emit = defineEmits(['select']);


  const state = computed(() => props.stateFn(props.item, { selected: isSelected.value }));
  const isSelected = computed(() => props.isSelectedFn(props.item));

  const classList = computed(() => {
    const list = ['og-select-result'];

    if (isSelected.value) {
      list.push('og-select-result--selected');
    }

    // disabled attribute doesn't work on divs?
    if (state.value.disabled) {
      list.push('og-select-result--disabled');
    }

    return list;
  });

  function onClick(event) {
    // check if any text is highlighted
    const selection = window.getSelection().toString();

    if (selection) {
      return;
    }

    event.stopPropagation();

    if (state.value.disabled) {
      return;
    }

    emit('select', props.item);
  }
</script>

